import { IFormTransDocument } from "./types";

// Suy MIME type theo phần mở rộng file để tải xuống đúng định dạng.
const MIME_BY_EXT: Record<string, string> = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  bmp: "image/bmp",
  webp: "image/webp",
  svg: "image/svg+xml",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv",
  txt: "text/plain",
};

export const getMimeType = (fileType?: string): string =>
  MIME_BY_EXT[(fileType || "").toLowerCase()] || "application/octet-stream";

// Làm sạch tên file + bảo đảm có phần mở rộng khớp fileType.
// Loại ký tự tách đường dẫn (/, \) và dấu chấm đầu để tránh path traversal
// ở tên gợi ý khi tải xuống.
const ensureFileName = (name?: string, ext?: string): string => {
  const base = (name || "")
    .replace(/[/\\]/g, "_")
    .replace(/^\.+/, "")
    .trim();
  const safeName = base || "document";
  const e = (ext || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  if (!e) return safeName;
  return safeName.toLowerCase().endsWith(`.${e}`) ? safeName : `${safeName}.${e}`;
};

// Kích hoạt tải xuống 1 file (blob) qua thẻ <a> tạm.
const triggerDownload = (href: string, fileName: string): void => {
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Tải xuống file chứng từ đã upload (lưu dạng base64 trong form state).
 * Dùng chung cho màn Xác nhận (step 4) và màn kết quả (step 5).
 */
export const downloadFormDocument = (doc?: IFormTransDocument): void => {
  if (!doc?.fileContent) return;
  const mime = getMimeType(doc.fileType);
  const fileName = ensureFileName(doc.documentName, doc.fileType);
  try {
    const byteChars = atob(doc.fileContent);
    const bytes = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i += 1) {
      bytes[i] = byteChars.charCodeAt(i);
    }
    const url = URL.createObjectURL(new Blob([bytes], { type: mime }));
    triggerDownload(url, fileName);
    URL.revokeObjectURL(url);
  } catch {
    // Fallback: dùng thẳng data URL nếu môi trường không hỗ trợ Blob/atob.
    triggerDownload(`data:${mime};base64,${doc.fileContent}`, fileName);
  }
};
